var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.counterObj
    ? _c(
        "div",
        { attrs: { id: "countdown" } },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "auto" } },
                [
                  _c("h3", { staticClass: "m-0" }, [
                    _vm._v(_vm._s(_vm.counterObj.days)),
                  ]),
                  _c("p", { staticClass: "m-0 lead" }, [
                    _vm._v(_vm._s(_vm.$t("countdown.days"))),
                  ]),
                ]
              ),
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "auto" } },
                [
                  _c("h3", { staticClass: "m-0" }, [
                    _vm._v(_vm._s(_vm.counterObj.hours)),
                  ]),
                  _c("p", { staticClass: "m-0 lead" }, [
                    _vm._v(_vm._s(_vm.$t("countdown.hours"))),
                  ]),
                ]
              ),
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "auto" } },
                [
                  _c("h3", { staticClass: "m-0" }, [
                    _vm._v(_vm._s(_vm.counterObj.minutes)),
                  ]),
                  _c("p", { staticClass: "m-0 lead" }, [
                    _vm._v(_vm._s(_vm.$t("countdown.minutes"))),
                  ]),
                ]
              ),
              _c(
                "b-col",
                { staticClass: "text-center", attrs: { cols: "auto" } },
                [
                  _c("h3", { staticClass: "m-0" }, [
                    _vm._v(_vm._s(_vm.counterObj.seconds)),
                  ]),
                  _c("p", { staticClass: "m-0 lead" }, [
                    _vm._v(_vm._s(_vm.$t("countdown.seconds"))),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }